import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import RedefinirSenha from '../views/RedefinirSenha.vue';

// CONVITES USUÁRIOS
import ConvitesUsuariosIndex from '../views/convites_usuarios/ConvitesUsuariosIndex.vue';
// PACIENTES
import PacientesIndex from '../views/pacientes/PacientesIndex.vue';
import MedicoesIndex from '../views/medicoes/MedicoesIndex.vue';
import PacientesCadastroExterno from '../views/pacientes/PacientesCadastroExterno.vue';
import PacientesVer from '../views/pacientes/PacientesVer.vue';
import PacientesGestantesPreNatal from '../views/pacientes/PacientesGestantesPreNatal.vue';
import PacientesFinalizarGestacao from '../views/pacientes/PacientesFinalizarGestacao.vue';
// GESTACOES
import GestacoesNascidos from '../views/gestacoes/GestacoesNascidos.vue';
// INTERNACOES
import InternacoesIndex from '../views/internacoes/InternacoesIndex.vue';
import InternacoesVer from '../views/internacoes/InternacoesVer.vue';
// RESULTADOS DE EXAMES
import ResultadosDeExamesNovo from '../views/resultados_de_exames/ResultadosDeExamesNovo.vue';
// USUÁRIOS
import UsuariosCadastrar from '../views/usuarios/UsuariosCadastrar.vue';
import UsuariosIndex from '../views/usuarios/UsuariosIndex.vue';
import UsuariosCadastrarPaciente from '../views/usuarios/UsuariosCadastrarPaciente.vue';
// CONSULTAS
import ConsultasVer from '../views/consultas/ConsultasVer.vue';
import ConsultasAtender from '../views/consultas/ConsultasAtender.vue';
// CONSULTAS COLETIVAS
import ConsultasColetivasIndex from '../views/consultas_coletivas/ConsultasColetivasIndex.vue';
import ConsultaColetivaAtiva from '../views/consultas_coletivas/ConsultaColetivaAtiva.vue';
// TEXTOS EDITAVEIS
import TextosEditaveisIndex from '../views/textos_editaveis/TextosEditaveisIndex.vue';
import TextosEditaveisAlterar from '../views/textos_editaveis/TextosEditaveisAlterar.vue';
import requester from '@/requester';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      public: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Fazer login',
      public: true,
    },
  },
  {
    path: '/redefinir_senha',
    name: 'RedefinirSenha',
    component: RedefinirSenha,
    meta: {
      title: 'Redefinir senha',
      public: true,
    },
  },
  // PACIENTES
  {
    path: '/cadastro',
    name: 'PacientesCadastroExterno',
    component: PacientesCadastroExterno,
    meta: {
      title: 'Cadastro',
      public: true,
    },
  },
  {
    path: '/pacientes',
    name: 'PacientesIndex',
    component: PacientesIndex,
    meta: {
      title: 'Pacientes',
    },
  },
  {
    path: '/medicoes',
    name: 'MedicoesIndex',
    component: MedicoesIndex,
    meta: {
      title: 'Registro de medições',
    },
  },
  {
    path: '/paciente/:pacienteId',
    name: 'PacientesVer',
    component: PacientesVer,
    meta: {
      title: 'Paciente',
    },
  },
  {
    path: '/gestantes_pre_natal',
    name: 'PacientesGestantesPreNatal',
    component: PacientesGestantesPreNatal,
    meta: {
      title: 'Gestantes Pré-Natal',
    },
  },
  {
    path: '/paciente/:pacienteId/finalizar_gestacao/:gestacaoId',
    name: 'PacientesFinalizarGestacao',
    component: PacientesFinalizarGestacao,
    meta: {
      title: 'Finalizar gestação',
    },
  },
  // GESTACOES
  {
    path: '/nascidos',
    name: 'GestacoesNascidos',
    component: GestacoesNascidos,
    meta: {
      title: 'Nascidos',
    },
  },
  // INTERNACOES
  {
    path: '/internacoes',
    name: 'InternacoesIndex',
    component: InternacoesIndex,
    meta: {
      title: 'Internações',
    },
  },
  {
    path: '/internacoes/:internacaoId',
    name: 'InternacoesVer',
    component: InternacoesVer,
    meta: {
      title: 'Internação',
    },
  },
  // RESULTADOS DE EXAMES
  {
    path: '/resultados_de_exames/:pacienteId/:gestacaoId',
    name: 'ResultadosDeExamesNovo',
    component: ResultadosDeExamesNovo,
    meta: {
      title: 'Resultados de Exames',
    },
  },
  // CONVITES USUÁRIOS
  {
    path: '/convites_usuarios',
    name: 'ConvitesUsuariosIndex',
    component: ConvitesUsuariosIndex,
    meta: {
      title: 'Convites de usuários',
    },
  },
  // USUÁRIOS
  {
    path: '/usuarios',
    name: 'UsuariosIndex',
    component: UsuariosIndex,
    meta: {
      title: 'Usuários',
    },
  },
  {
    path: '/usuarios/cadastrar',
    name: 'UsuariosCadastrar',
    component: UsuariosCadastrar,
    meta: {
      title: 'Cadastro de usuário',
      public: true,
    },
  },
  {
    path: '/usuarios/cadastrar_paciente',
    name: 'UsuariosCadastrarPaciente',
    component: UsuariosCadastrarPaciente,
    meta: {
      title: 'Cadastro de senha de acesso',
      public: true,
    },
  },
  // CONSULTAS COLETIVAS
  {
    path: '/consultas_coletivas',
    name: 'ConsultasColetivasIndex',
    component: ConsultasColetivasIndex,
    meta: {
      title: 'Consultas Coletivas',
    },
  },
  {
    path: '/consulta_coletiva/:consultaColetivaId',
    name: 'ConsultaColetivaAtiva',
    component: ConsultaColetivaAtiva,
    meta: {
      title: 'Consulta Coletiva',
    },
  },
  // CONSULTAS
  {
    path: '/consulta/:consultaId',
    name: 'ConsultasVer',
    component: ConsultasVer,
    meta: {
      title: 'Consulta presencial',
    },
  },
  {
    path: '/consulta/atendimento/:consultaId',
    name: 'ConsultasAtender',
    component: ConsultasAtender,
    meta: {
      title: 'Atendimento consulta presencial',
    },
  },
  // TEXTOS EDITAVEIS
  {
    path: '/textos_editaveis',
    name: 'TextosEditaveisIndex',
    component: TextosEditaveisIndex,
    meta: {
      title: 'Textos editáveis do sistema',
    },
  },
  {
    path: '/textos_editaveis/alterar/:textoEditavelId',
    name: 'TextosEditaveisAlterar',
    component: TextosEditaveisAlterar,
    meta: {
      title: 'Textos editáveis do sistema',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    await requester.usuario.checkToken();
  } catch (err) {
    if (!to.meta.public) {
      store.dispatch('logout');
      router.push({ name: 'Login', query: { redirect: to.path, loggedOut: 'true' } });
    }
  }
  if (from) {
    store.dispatch('setPreviousRoute', {
      name: from.name,
      params: from.params,
    });
  } else {
    store.dispatch('setPreviousRoute', null);
  }
  next();
});

export default router;
